import { Sparkles } from "lucide-react";

export default function ElContaAvatar({ small = false }) {
  return <div className={`conta-avatar ${small ? "small" : ""}`} data-testid="el-conta-avatar"><div className="face"><i></i><i></i><b></b></div>{!small && <Sparkles className="spark" size={17} />}</div>;
}